/**
 * The OrlandoSyncLogo component
 * @param {{className: string}} props The component props
 * @returns {React.ReactElement<{ className: string }>} The OrlandoSyncLogo component
 */
export function OrlandoSyncLogo({ className }) {
  return (
    <div className={className}>
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" fill="url(#paint0_linear_9085_134)" />
        <path
          d="M35.625 23.8125C35.625 30.3364 30.3364 35.625 23.8125 35.625C17.2886 35.625 12 30.3364 12 23.8125C12 17.2886 17.2886 12 23.8125 12C30.3364 12 35.625 17.2886 35.625 23.8125ZM16.9013 23.8125C16.9013 27.6295 19.9955 30.7237 23.8125 30.7237C27.6295 30.7237 30.7237 27.6295 30.7237 23.8125C30.7237 19.9955 27.6295 16.9013 23.8125 16.9013C19.9955 16.9013 16.9013 19.9955 16.9013 23.8125Z"
          fill="#E6F3FA"
        />
        <path
          d="M31.5 23.875C31.5 28.2242 27.9742 31.75 23.625 31.75C19.2758 31.75 15.75 28.2242 15.75 23.875C15.75 19.5258 19.2758 16 23.625 16C27.9742 16 31.5 19.5258 31.5 23.875ZM19.0175 23.875C19.0175 26.4196 21.0804 28.4825 23.625 28.4825C26.1696 28.4825 28.2325 26.4196 28.2325 23.875C28.2325 21.3304 26.1696 19.2675 23.625 19.2675C21.0804 19.2675 19.0175 21.3304 19.0175 23.875Z"
          fill="#278CBA"
        />
        <defs>
          <linearGradient id="paint0_linear_9085_134" x1="24" y1="0" x2="24" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#000099" />
            <stop offset="1" stopColor="#000066" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default OrlandoSyncLogo;
